module.exports = __webpack_public_path__ + "img/dt.7254bd79.png";